<template>
  <div class="container-fluid">
    <form id="searchForm" class="form form-horizontal"  role="form" @submit.stop.prevent method="post">
      <div class="form-group">
        <div class="col-xs-1">
          <router-link class="btn btn-sm btn-primary" :to="{name: 'home'}"><i class="fa fa-home"></i></router-link>
        </div>
        <div class="col-xs-9 input-group-sm">
          <input type="search" name="term" class="form-control search-fixed-top" id="search-shop" placeholder="Search the shop here" style="font-family:Arial, FontAwesome">
        </div>
        <div class="col-xs-1">
          <a class="btn btn-sm btn-primary" href="tel:01706750293"><i class="fa fa-phone"></i></a>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'search-bar'
}
</script>